import { render, staticRenderFns } from "./UpdateSupplierPopUp.vue?vue&type=template&id=2c8c0d1d&scoped=true"
import script from "./UpdateSupplierPopUp.vue?vue&type=script&lang=js"
export * from "./UpdateSupplierPopUp.vue?vue&type=script&lang=js"
import style0 from "./UpdateSupplierPopUp.vue?vue&type=style&index=0&id=2c8c0d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c0d1d",
  null
  
)

export default component.exports